import { List } from 'immutable'
import _get from 'lodash/get'
import _isUndefined from 'lodash/isUndefined'
import { createAuthorization } from '../auth'
import {
  ROLE_AMBASSADOR_ADMIN,
  ROLE_MANAGE_PLANS_MARKETING,
  ROLE_MANAGE_PLANS_PRODUCT,
  ROLE_SITE_ADMIN,
} from '../auth/roles'
import { MENU_ITEMS } from '../constants'
import request from '../request'

/**
 * Get menus by platform, type, and language
 */
export async function getMenusUnder ({ auth, server, platform, type, language }) {
  const query = {}
  if (platform) {
    query.platform = platform
  }
  if (type) {
    query.type = type
  }
  if (language) {
    query.language = language
  }
  const res = await request
    .get(`${server}/v2/menu`)
    .query(query)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

export async function createMenu ({ auth, server, newMenu }) {
  const res = await request
    .post(`${server}/v2/menu`)
    .send(newMenu)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}

export const getMenuPermissions = ({ config, auth }) => {
  const enableContentManagement = config.getIn(['data', 'features', 'enableContentManagement'])
  const enableContentPolicyManagement = config.getIn([
    'data',
    'features',
    'enableContentPolicyManagement',
  ])
  const enableMediaManagement = config.getIn(['data', 'features', 'enableMediaManagement'])
  const enableTextTracksBulkUpload = config.getIn([
    'data',
    'features',
    'enableTextTracksBulkUpload',
  ])
  const enableAmbassadors = config.getIn(['data', 'features', 'enableAmbassadors'])
  // const hasAccessCmsV2Permission = auth.getIn(['data', 'permissions'], List())
  //   .includes(PERM_ACCESS_CMS_V2)
  const hasAmbassadorAdminRole = auth
    .getIn(['data', 'roleIds'], List())
    .includes(ROLE_AMBASSADOR_ADMIN)

  const planCmsEnabled = !!config.getIn(['data', 'features', 'plans', 'cmsEnabled'])
  const planCmsMenuLinksEnabled = !!config.getIn([
    'data',
    'features',
    'plans',
    'cmsMenuLinksEnabled',
  ])
  const hasManagePlansRole = auth
    .getIn(['data', 'roleIds'], List())
    .some(
      (r) =>
        r === ROLE_MANAGE_PLANS_MARKETING ||
        r === ROLE_MANAGE_PLANS_PRODUCT ||
        r === ROLE_SITE_ADMIN,
    )

  const enableQaTools = config.getIn(['data', 'features', 'enableQaTools']) === true

  return {
    '/content': enableContentManagement,
    '/v2/content': enableContentManagement,
    '/content-policy': enableContentPolicyManagement,
    '/media': enableMediaManagement,
    '/text-tracks': enableTextTracksBulkUpload,
    '/ambassadors': enableAmbassadors && hasAmbassadorAdminRole,
    '/plan-management': planCmsEnabled && planCmsMenuLinksEnabled && hasManagePlansRole,
    '/qa': enableQaTools,
  }
}

export const getFilteredMenuItems = (props) => {
  const menuPermissions = getMenuPermissions(props)

  return MENU_ITEMS.filter(
    (item) => _isUndefined(menuPermissions[item.path]) || menuPermissions[item.path],
  )
}
